<div
  #slider
  class="flex flex-row items-start max-lg:overflow-x-auto clip max-lg:gap-10 lg:gap-6 lg:justify-between pt-2 lg:pt-4 max-lg:px-8 lg:px-28 ssxl:px-36"
  [ssDirectus]="{
    collection: 'infoCarousel',
    item: infoCarouselData().id,
    fields: ['infoItems'],
  }"
  [ngClass]="{
    'split-color':
      getActiveItemIsDark(activeIndex()) &&
      infoCarouselData().infoItems[activeIndex()]?.icon,
    'split-color-light':
      !getActiveItemIsDark(activeIndex()) &&
      infoCarouselData().infoItems[activeIndex()]?.icon,
    'split-color-no-icon':
      getActiveItemIsDark(activeIndex()) &&
      !infoCarouselData().infoItems[activeIndex()]?.icon,
    'split-color-no-icon-light':
      !getActiveItemIsDark(activeIndex()) &&
      !infoCarouselData().infoItems[activeIndex()]?.icon,
  }"
>
  @for (
    item of infoCarouselData()?.infoItems;
    track trackInfoItems(index, item);
    let index = $index
  ) {
    <div
      class="flex flex-col items-center justify-center"
      role="button"
      tabindex="0"
      (click)="setActiveIndex(index)"
      (keydown.enter)="setActiveIndex(index)"
    >
      @if (item.icon && activeIndex() !== index) {
        <ss-www-image-with-loader
          class="h-7 w-7 lg:h-10 lg:w-10 active-slide"
          objectFit="contain"
          [fileDetail]="item.icon"
          desktopImageSize="half"
        ></ss-www-image-with-loader>
      }
      @if (item.activeIcon && activeIndex() === index) {
        <ss-www-image-with-loader
          objectFit="contain"
          class="h-7 w-7 lg:h-10 lg:w-10 active-slide"
          [fileDetail]="item.activeIcon"
          desktopImageSize="half"
        ></ss-www-image-with-loader>
      }
      <div
        class="text-xxs lg:text-xs font-campan tracking-widest font-medium uppercase text-center my-3"
        [ssDirectus]="{
          collection: 'infoCarouselItems',
          item: item.id,
          fields: ['title'],
        }"
        [ngClass]="{
          'active-slide': index === activeIndex(),
          'whitespace-nowrap': item.titleSingleLine,
          'max-w-[125px]': !item.titleSingleLine,
          'mt-2': item.icon,
        }"
      >
        {{ item.title }}
      </div>
      @if (index === activeIndex()) {
        <div class="h-1 gold-gradient self z-10 self-stretch"></div>
      }
    </div>
  }
</div>
@if (showScrollForMore()) {
  <div
    class="flex gap-4 items-center pl-8 pb-5 pt-2"
    [ngClass]="{
      'text-ss-brown bg-white': !getActiveItemIsDark(activeIndex()),
    }"
  >
    <div class="text-xxs tracking-widest">SWIPE FOR MORE</div>
    <svg
      width="23"
      height="6"
      viewBox="0 0 23 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Vector 80"
        d="M0 3H22M22 3L19.5 0.5M22 3L19.5 5.5"
        stroke="currentColor"
      />
    </svg>
  </div>
}

<div
  class="relative overflow-hidden"
  [ngClass]="
    infoCarouselData()?.infoItems?.[0]?.faqsBlock?.darkBackground === false ||
    infoCarouselData()?.infoItems?.[0]?.infoBlock?.invert
      ? 'bg-white'
      : ''
  "
>
  @for (
    item of infoCarouselData()?.infoItems;
    track trackInfoItems(index, item);
    let index = $index
  ) {
    @if (item?.infoBlock) {
      <ss-www-side-by-side-image-text
        [@slideRoundChild]="{
          value: index === activeIndex() ? 'in' : 'out',
          params: { toLeft },
        }"
        class="hidden mt-2 lg:mt-10"
        [sideBySideImageTextData]="item.infoBlock!"
        [lastBlock]="false"
        [disableAnimation]="true"
      ></ss-www-side-by-side-image-text>
    } @else if (item?.faqsBlock) {
      <ss-www-faqs
        [@slideRoundChild]="{
          value: index === activeIndex() ? 'in' : 'out',
          params: { toLeft },
        }"
        class="hidden"
        [faqData]="item.faqsBlock!"
        [lastBlock]="false"
      ></ss-www-faqs>
    }
  }
</div>
